<template>
  <div>
    <h1 class="title-form-ipt">{{ categoryName }}</h1>
    <template v-if="subQuetions.length > 0">
      <div v-for="subquestion in subQuetions" :key="subquestion.subcategory_id">
        <h1 class="subtitle-form-ipt">{{ subquestion?.subcategory }}</h1>
        <div v-for="question in subquestion.questions" :key="question.id">
          <div class="mt-4" v-if="question.isStatus">
            <p class="ask-form-ipt">
              <!-- {{ question.number }}.  -->
              {{ question.question }}
              <strong>*</strong>
            </p>
            <input-check-box
              :options="options"
              :id="question.id"
              :isBusy="isBusy"
              :isDetail="isDetail"
              :answer="question.answer"
              @answerQuestion="
                (value) =>
                  $emit('answerQuestion', {
                    ...value,
                    categoryId: categoryId,
                    question_dependencies: question?.question_dependencies,
                    is_answer: question?.is_answer,
                    subcategory_id: subquestion?.subcategory_id,
                  })
              "
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="question in questions" :key="question.id">
        <div class="mt-4" v-if="question.isStatus">
          <p class="ask-form-ipt">
            <!-- {{ question.number }}. -->
            {{ question.question }}
            <strong>*</strong>
          </p>
          <input-check-box
            :options="options"
            :id="question.id"
            :isBusy="isBusy"
            :isDetail="isDetail"
            :answer="question.answer"
            @answerQuestion="
              (value) =>
                $emit('answerQuestion', {
                  ...value,
                  categoryId: categoryId,
                  question_dependencies: question?.question_dependencies,
                  is_answer: question?.is_answer,
                  subcategory_id: null,
                })
            "
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import InputCheckBox from "./InputCheckBox.vue";

export default {
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    subQuetions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
    categoryId: {
      type: Number,
      default: 0,
    },
    categoryName: {
      type: String,
      default: "",
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InputCheckBox,
  },
  watch: {
    answers() {
      const me = this;
      console.log(me.answers);
    },
  },
  data() {
    return {
      options: [
        { text: "Si", value: "1" },
        { text: "No", value: "0" },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.alert-warning-form-ipt {
  border: 1px solid #0075ff !important;
  border-radius: 4px !important;
  background-color: #e6f7ff !important;
  margin-bottom: 40px;
}

.hr-form-ipt {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
}

.hr-form-ipt2 {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
  width: 10% !important;
}

.title-form-ipt {
  font-family: Ubuntu !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  line-height: 28px !important;
  text-align: left !important;
  color: #5d5fef !important;
  text-transform: none !important;
}

.subtitle-form-ipt {
  font-family: Ubuntu !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 28px !important;
  text-align: left !important;
  color: #5d5fef !important;
  text-transform: none !important;
}

.ask-form-ipt {
  color: #37474f !important;
  font-family: Ubuntu !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 28px !important;
  text-align: left !important;
}

.ask-form-ipt strong {
  color: #da1414 !important;
}
</style>
